import L from 'leaflet';
import openGeocoder from 'node-open-geocoder';
import moment from 'moment';
const locationCache = require('../data/locationCache.json');
const locationMapper = require('../utils/locationMapper').get;

export const getCoordinates = async location =>
  new Promise((resolve, reject) => {
    // console.log(locationCache)
    // const locationCache = fs.readFileSync(LOCATION_CACHE_PATH)
    // const parsedCache = JSON.parse(locationCache) || [];
    location = locationMapper(location);

    const cachedLocation = locationCache.filter(
      loc => loc.location === location
    );
    // console.log(cachedLocation)
    if (cachedLocation.length) {
      const { lat, lon } = cachedLocation[0].geocode;
      // console.log(location, lat, lon, '(cached)');
      const normalisedLatlng = L.latLng(
        Number.parseFloat(lat),
        L.Util.wrapNum(Number.parseFloat(lon), [-30, 330], true)
      );
      // .wrap()
      resolve(normalisedLatlng);
      // resolve(coords);
    } else {
      openGeocoder()
        .geocode(location)
        .end((err, response) => {
          if (err) return reject(err);
          // console.log(response)
          // parsedCache.push(response);
          // fs.writeFileSync(LOCATION_CACHE_PATH,JSON.stringify(parsedCache))
          const { lat, lon } = response[0];
          const coords = [Number.parseFloat(lat), Number.parseFloat(lon)];
          return resolve(coords);
        });
    }
  });
  
export const getMarkerIcon = patient => {
  const isProbable = patient.status === 'probable';
  const options = {
    isAlphaNumericIcon: true,
    text: `Case
    ${patient.case_number}${isProbable ? '*' : ''}`,
    iconShape: 'circle',
    iconSize: [36, 36],
    iconAnchor: [18, 18],
    tooltipAnchor: [20, 0],
    borderColor: '#333',
    textColor: '#333'
  };
  if (isProbable) options.backgroundColor = 'lightgray';
  return L.BeautifyIcon.icon(options);
};

export const getMarkerIcon_old = () => {
  const defaultMarker =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII=';

  const defaultMarkerShadow =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC';

  return new L.Icon({
    iconUrl: defaultMarker,
    iconAnchor: [12, 41],
    popupAnchor: [0, -41],
    tooltipAnchor: [14, -30],
    shadowUrl: defaultMarkerShadow
  });
};


export const getFormattedDateString = (date, time = '') => {
  if (!date) return 'Date not available';
  console.log(date + ' ' + time);
  return moment(date + ' ' + time).format('D MMM h:mm a');
};

export const getFormattedDateString_old = date => {
  if (!date) return 'Date not available';
  const newDate = new Date(date);
  const options = {
    day: '2-digit',
    month: 'short'
  };
  if (newDate.getHours() || newDate.getMinutes()) {
    options.hour = '2-digit';
    options.minute = '2-digit';
    options.hourCycle = 'h12';
  }
  return newDate.toLocaleString('en-NZ', options);
};

export const getFlightMarkers = async (flight) => {

  const flightEventMarker = async (flightEvent) => {
    const coords = await getCoordinates(flightEvent.airport);
    const evtDate = moment(flightEvent.date + ' ' + flightEvent.time).format(
      'D MMM h:mm a'
      );
      return L.marker(coords, {
        icon: getMarkerIcon_old(),
      }).bindTooltip(`${flightEvent.airport}<br>${evtDate}`, {
        permanent: true,
      });
    };
const depMarker = await flightEventMarker(flight.departed);
const arrMarker = await flightEventMarker(flight.arrived);
// console.log(depMarker, arrMarker);
const line = new L.polyline(
  [depMarker.getLatLng(), arrMarker.getLatLng()],
  { wrap: false, steps: 10 }
);
  return [depMarker, arrMarker, line]
}